import { Injectable } from '@angular/core';
import { QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';
import { SearchClientBankAccountsQuery, SearchClientBankAccountsQueryHandlerBase } from '@skylab-shared/business';

@Injectable({ providedIn: 'root' })
@QueryHandlerFor(SearchClientBankAccountsQuery)
@Wrapper(SearchClientBankAccountsQueryHandlerBase)
export class SearchClientBankAccountsQueryHandler {}
